import { Route } from '@angular/router';
import { routes as authShellRouting } from '@portal-front/portal-auth-feature-shell';

export const appRoutes: Route[] = [
  { path: '', children: authShellRouting },
  { path: '**', redirectTo: '' },
];
